import { ModuleInfo } from "fabrix/types";
import { FabrixIcon } from "../../fabrix/common/icons";
import { RequireAuth } from "../../fabrix/components/authentication/auth-validation";
import { FabrixSocketsService } from "../../fabrix/services/socket";
import { icons } from "./icons";


export const initSockets = () => {
    let service = FabrixSocketsService.instance;
    service.init("das", ["doc-ai"]);
}

const moduleRoutes = (): ModuleInfo => {
  let routes = {
    path: "/document-agent",
    label: "DOCUMENT_AGENT",
    name: "document-agent",
    roles: [],
    id: "c73b1c0a-9e1e-4617-b01e-39f95dee129d", //Must the be module Id.
    lazy: async () => {
      const Page = (await import("./")).default;
      return {
        element: (
          <RequireAuth roles={[]}>
            <Page />
          </RequireAuth>
        ),
      };
    },
    translations: {},
    icons: icons,
    children: [
      {
        path: "/document-agent/",
        label: "HOME",
        name: "home",
        group: "home",
        icon: FabrixIcon.home,
        hide: true,
        id: "8391440a-c771-465f-8c9f-fb5edbf14ca6",
        roles: [],
        lazy: async () => {
          const Page = (await import("./routes/home")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/documents",
        label: "DOCUMENTS",
        name: "documents",
        group: "home",
        hide: false,
        id: "1fb46640-7414-43c0-9ca3-486030c55d90",
        roles: [],
        icon: "da-documents",
        lazy: async () => {
          const Page = (await import("./routes/documents")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/conical",
        label: "CONICAL_DATA",
        name: "conical-data",
        group: "home",
        hide: false,
        id: "d0bf6b27-080e-4a64-89db-f31ff1c12545",
        roles: [],
        icon: "da-conical",
        lazy: async () => {
          const Page = (await import("./routes/conical/home")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/keywords",
        label: "AI_KEYWORDS",
        name: "ai-keywords",
        group: "home",
        hide: false,
        id: "e98cf96d-5982-4ecb-92c4-a1b7a8882d64",
        roles: [],
        icon: "da-keywords",
        lazy: async () => {
          const Page = (await import("./routes/keyword-index")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/conical/provinces",
        label: "DA_PROVINCES",
        name: "provinces",
        group: "conical",
        hide: false,
        id: "c9d7e4c7-8e8f-4dc5-9944-acde85455cc7",
        roles: [],
        icon: "da-provinces",
        lazy: async () => {
          const Page = (await import("./routes/conical/province")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/conical/districts",
        label: "DA_DISTRICTS",
        name: "districts",
        group: "conical",
        hide: false,
        id: "618de703-b824-49d5-91e9-84fbd8d7cd70",
        roles: [],
        icon: "da-districts",
        lazy: async () => {
          const Page = (await import("./routes/conical/district")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/conical/municipality-categories",
        label: "DA_MUNICIPALITY_CATEGORIES",
        name: "municipality-categories",
        group: "conical",
        hide: false,
        id: "07709219-2eb1-4f64-9179-fb489422b2b5",
        roles: [],
        icon: "da-municipality-categories",
        lazy: async () => {
          const Page = (await import("./routes/conical/municipality-category")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/conical/municipalities",
        label: "DA_MUNICIPALITIES",
        name: "municipalities",
        group: "conical",
        hide: false,
        id: "8cc2171c-5c1a-42f6-a452-335f42db80a4",
        roles: [],
        icon: "da-municipalities",
        lazy: async () => {
          const Page = (await import("./routes/conical/municipality")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/conical/departments",
        label: "DA_DEPARTMENTS",
        name: "departments",
        group: "conical",
        hide: false,
        id: "443bddcb-ddf5-4c3d-9b87-0b921dcc7dfa",
        roles: [],
        icon: "da-departments",
        lazy: async () => {
          const Page = (await import("./routes/conical/department")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/imports",
        label: "IMPORTS",
        name: "imports",
        group: "home",
        hide: false,
        id: "8e12cbaf-54a8-4aa2-9089-b6de3dc2575e",
        roles: [],
        icon: "da-history",
        lazy: async () => {
          const Page = (await import("./routes/imports")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/chat",
        label: "CHAT",
        name: "chat",
        group: "home",
        hide: false,
        id: "8b5ca91e-f917-4a85-8e59-2c987ed067bb",
        roles: [],
        icon: "da-agent",
        lazy: async () => {
          const Page = (await import("./routes/chat")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/document-agent/prompts",
        label: "PROMPTS",
        name: "prompts",
        group: "home",
        hide: false,
        id: "ac25b2bf-6a80-45a4-be63-ea61eb74b9c4",
        roles: [],
        icon: "da-prompts",
        lazy: async () => {
          const Page = (await import("./routes/prompts")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      }

    ],
  };
  return routes;
};

export default moduleRoutes;
